import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";
import {
  MIDDLE_WARE_BASE_URL_v1,
  GET_CONFIRM_AGENT_SCHEDULE,
} from "../../../utils/CONSTANTS";

const initialState = {
  getConfirmAgentScheduleState: "pending",
  getConfirmAgentScheduleData: null,
};

export const getConfirmAgentSchedule = createAsyncThunk(
  "get/getConfirmAgentSchedule",
  async (data: any) => {
    const response = axios.getRequest(
      MIDDLE_WARE_BASE_URL_v1() +
        GET_CONFIRM_AGENT_SCHEDULE() +
        "?classRosterId=" +
        data?.classRosterId +
        "&classRequestId=" +
        data?.classRequestId +
        "&OracleId=" +
        data?.oracleId
    );
    return response;
  }
);

const getConfirmAgentScheduleSlice = createSlice({
  name: "getConfirmAgentSchedule",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(
        getConfirmAgentSchedule.pending,
        (getConfirmAgentScheduleState) => {
          getConfirmAgentScheduleState.getConfirmAgentScheduleState = "pending";
        }
      )
      .addCase(
        getConfirmAgentSchedule.fulfilled,
        (getConfirmAgentScheduleState, action) => {
          let tempRes = action.payload.data;
          if (typeof tempRes === "string") {
            tempRes = JSON.parse(tempRes);
          }

          if (tempRes && tempRes.length > 0) {
            getConfirmAgentScheduleState.getConfirmAgentScheduleState =
              "fulfilled";
            getConfirmAgentScheduleState.getConfirmAgentScheduleData =
              tempRes[0];
          } else {
            getConfirmAgentScheduleState.getConfirmAgentScheduleState =
              "failed";
            getConfirmAgentScheduleState.getConfirmAgentScheduleData = null;
          }
          //console.log("Inside Slice ", tempRes);
        }
      )
      .addCase(
        getConfirmAgentSchedule.rejected,
        (getConfirmAgentScheduleState) => {
          getConfirmAgentScheduleState.getConfirmAgentScheduleState = "failed";
        }
      ),
});

export const getConfirmAgentScheduleDetails = (state: any) =>
  state.getConfirmAgentSchedule;

export default getConfirmAgentScheduleSlice.reducer;
